/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface SimulateRaceGet$Params {
  RaceGuid: string;
  lowerDelayMs: number;
  upperDelayMs: number;
}

export function simulateRaceGet(http: HttpClient, rootUrl: string, params: SimulateRaceGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, simulateRaceGet.PATH, 'get');
  if (params) {
    rb.query('RaceGuid', params.RaceGuid, {});
    rb.query('lowerDelayMs', params.lowerDelayMs, {});
    rb.query('upperDelayMs', params.upperDelayMs, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<any>;
    })
  );
}

simulateRaceGet.PATH = '/simulate-race';
